export default "__VITE_ASSET__B7Lc6fE5__"